import { normalizePath, useSetFlowTo } from 'Simple/Flow'
import { useMutation } from 'Data/Api.js'
import { useDataChange, useDataSubmit, useDataValue } from 'Simple/Data.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import mutation from './mutation.graphql.js'
import {
  APPS_LAUNCHERS_TYPES,
  LAUNCHER_DISPLAY_FORMATS,
  MULTIPLE_CONNECTIONS_FOUND,
} from 'Data/common-constants.js'

export default function useListItemDataOnSubmit(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    path: 'patient_id',
    context: 'tab',
  })
  let location_id = useDataValue({
    context: 'global',
    path: 'current_location._id',
    viewPath: props.viewPath,
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    context: 'component',
    viewPath: props.viewPath,
  })

  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  let changeComponent = useDataChange({
    viewPath: props.viewPath,
    context: 'component',
  })

  return async function onSubmit({ args, value, change }) {
    if (value.properties) {
      await submit({
        type: 'open_apps_launcher_properties',
        launcher: value,
      })

      return
    }

    if (value.type === APPS_LAUNCHERS_TYPES.ACTION_EXTERNAL_MAPPING_REMOVE) {
      if (!window.confirm(`Are you sure?`)) return
    }

    let mutationResponse = await executeMutation({
      id: value.id,
      resource_id: patient_id,
      location_id,
    })
    if (mutationResponse.error) {
      return notify(notifyError(`There was a problem launching the app.`))
    }

    if (!mutationResponse.data.apps_launchers_resolve.ok) {
      if (
        mutationResponse.data.apps_launchers_resolve.message ===
        MULTIPLE_CONNECTIONS_FOUND
      ) {
        changeComponent({
          onSubmit: () => this.current({ args, value, change }),
          app_id: value.app_id,
        })
        setFlowTo(normalizePath(props.viewPath, '../AssignConnection/Content'))
        return
      }

      changeComponent(null)

      return notify(
        notifyError(mutationResponse.data.apps_launchers_resolve.message)
      )
    }

    switch (value.type) {
      case APPS_LAUNCHERS_TYPES.URL_STATIC:
      case APPS_LAUNCHERS_TYPES.URL_HTTP: {
        switch (value.displayFormat) {
          case LAUNCHER_DISPLAY_FORMATS.MODAL_FULLSCREEN: {
            changeComponent({
              name: value.name,
              url: mutationResponse.data.apps_launchers_resolve.url,
            })
            setFlowTo(
              normalizePath(
                props.viewPath,
                '../../../../LauncherModalFullscreen/Content'
              )
            )
            break
          }

          case LAUNCHER_DISPLAY_FORMATS.NEW_WINDOW:
          default: {
            window.open(mutationResponse.data.apps_launchers_resolve.url)
            changeComponent(null)
            break
          }
        }
        break
      }

      // TODO: implement
      case APPS_LAUNCHERS_TYPES.ACTION_QR: {
        // setFlowTo(normalizePath(props.viewPath, 'ActionQr/Content'))
        changeComponent(null)
        break
      }

      // TODO: implement
      case APPS_LAUNCHERS_TYPES.ACTION_COMPONENT: {
        changeComponent(mutationResponse.data.apps_launchers_resolve.component)
        // TODO: make it internal to AppAction like the ACTION_QR one is on the topbar
        setFlowTo(normalizePath(props.viewPath, '../../../../AppComponent'))
        break
      }

      case APPS_LAUNCHERS_TYPES.ACTION_HTTP: {
        changeComponent(null)
        break
      }

      // TODO: implement
      case APPS_LAUNCHERS_TYPES.ACTION_EXTERNAL_MAPPING_REMOVE: {
        // setFlowTo(normalizePath(props.viewPath, 'ActionQr/Content'))
        changeComponent(null)
        break
      }

      default: {
        break
      }
    }

    if (mutationResponse.data.apps_launchers_resolve.message) {
      return notify(
        notifySuccess(mutationResponse.data.apps_launchers_resolve.message)
      )
    }
  }
}
